import useDpi from '../hooks/useDpi';
import PropTypes from 'prop-types';
import { TileWMS } from 'ol/source';
import { TileLayer } from 'os-elements';
import { useSelector } from 'react-redux';
import { withAuth } from './sources/BaseMap';
import { MAX_SCALE, MIN_SCALE, TILED_WMS_LAYER } from './constants';
import { apiBaseUrl } from 'client/utils/constants/frontEndConfig';
import { getEpsgCode } from 'client/utils/helpers/MapConfig/MapConfig';
import { useEffect, useState } from 'react';

const CustomBackdropMap = ({ zIndex, className }) => {
    const { getResolutionFromScale } = useDpi();
    const isolatedViewOwnerId = useSelector(state => state.map?.ownerId);
    const showCustomBackdrops = useSelector(state => state.map?.showCustomBackdrops);
    const visible = showCustomBackdrops && isolatedViewOwnerId !== null;
    const [customBackdropSource, setCustomBackdropSource] = useState();
    const minRes = getResolutionFromScale(MIN_SCALE);
    const maxRes = getResolutionFromScale(MAX_SCALE);

    useEffect(() => {
        getEpsgCode().then(epsgCode => {
            if (isolatedViewOwnerId) {
                setCustomBackdropSource(new TileWMS({
                    url: `${apiBaseUrl}/nuar-raster-data/ows`,
                    projection: `EPSG:${epsgCode}`,
                    params: {
                        LAYERS: [TILED_WMS_LAYER],
                        VIEWPARAMS: `assetowner_id:${isolatedViewOwnerId}`
                    },
                    tileLoadFunction: withAuth
                }));
            }
        });
    }, [isolatedViewOwnerId]);

    return customBackdropSource && <TileLayer
        data-testid='customBackdrop'
        id='customBackdrop'
        source={customBackdropSource}
        className={className}
        visible={visible}
        zIndex={zIndex}
        minResolution={minRes}
        maxResolution={maxRes}
    />;
};

CustomBackdropMap.propTypes = {
    zIndex: PropTypes.number,
    className: PropTypes.string
};

CustomBackdropMap.defaultProps = {
    zIndex: 0,
    className: ''
};

export default CustomBackdropMap;

export {
    CustomBackdropMap
};
